import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UserLogin {
  name: string;
  role: string;
}

interface UserLoginContextProps {
  userLogin: UserLogin | null;
  setUserLogin: (userLogin: UserLogin | null) => void;
}

const UserLoginContext = createContext<UserLoginContextProps>({
  userLogin: null,
  setUserLogin: () => {},
});

export const UserLoginProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [userLogin, setUserLogin] = useState<UserLogin | null>(null);

  // Provide correct value for context
  return (
    <UserLoginContext.Provider value={{ userLogin, setUserLogin: setUserLogin }}>
      {children}
    </UserLoginContext.Provider>
  );
};

export const useUserLogin = () => useContext(UserLoginContext);
